"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("./constants");
exports.default = {
    root: {
        display: 'flex',
        overflowX: 'auto',
        flexShrink: 0
    },
    actions: {
        flexGrow: 1,
        display: 'flex',
        justifyContent: 'flex-end',
        padding: constants_1.MODAL_PADDING
    },
    action: {
        marginLeft: 14
    },
    adverseAction: {
        flexGrow: 1
    }
};
//# sourceMappingURL=modal.actions.style.js.map